/*
  HYPE SIDE — carrossel contínuo (fotos de clientes, avaliações).

  Antes era uma animação CSS no track. Em computadores com "efeitos de
  animação" desligados (Windows) ou "reduzir movimento" (iPhone) o browser
  pede menos movimento: a animação parava e aparecia a barra de scroll.
  E como o track andava por transform, também não dava para arrastar.

  Agora o viewport é um scroll horizontal normal (barra escondida) e este
  script avança o scroll devagar. Funciona igual em todo o lado e deixa
  arrastar: dedo no telemóvel, rato/trackpad no computador.

  Uso:
    <div data-hs-loop data-hs-loop-sec="4">   (segundos por cartão)
      <div> ...cartões... ...os mesmos cartões outra vez... </div>
    </div>
*/
(function () {
  var PAUSA_TOQUE = 2500; // ms parado depois de a pessoa mexer

  function iniciar(vp) {
    if (vp.__hsLoop) return;
    vp.__hsLoop = true;
    var track = vp.firstElementChild;
    if (!track || track.children.length < 2) return;

    var segPorCartao = parseFloat(vp.getAttribute('data-hs-loop-sec')) || 5;
    var n = Math.floor(track.children.length / 2); // cartões de uma passagem
    var pos = 0;
    var volta = 0;       // largura de uma passagem
    var velocidade = 0;  // px por segundo
    var visivel = false;
    var hover = false;
    var paradoAte = 0;
    var anterior = 0;
    var arrasto = null;
    var moveu = false;

    function medir() {
      var primeiro = track.children[0];
      var clone = track.children[n];
      if (!primeiro || !clone) return;
      var nova = clone.offsetLeft - primeiro.offsetLeft;
      if (nova <= 0) return;
      // Passagens que chegue para andar sempre na segunda sem ver o fim
      // (com poucos cartões num ecrã largo, duas não chegavam)
      var passagens = track.children.length / n;
      while (passagens * nova < 2 * nova + vp.clientWidth + 1) {
        for (var i = 0; i < n; i++) {
          var c = track.children[i].cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          track.appendChild(c);
        }
        passagens++;
      }
      var inicio = volta === 0;
      volta = nova;
      velocidade = volta / (n * segPorCartao);
      pos = inicio ? volta : dentro(pos);
      vp.scrollLeft = pos;
    }

    // O scroll anda sempre dentro da segunda passagem: dá para ir para
    // a frente e para trás sem nunca bater no início ou no fim.
    function dentro(x) {
      if (volta <= 0) return x;
      while (x >= 2 * volta) x -= volta;
      while (x < volta) x += volta;
      return x;
    }

    function pausar() { paradoAte = performance.now() + PAUSA_TOQUE; }

    function frame(t) {
      var dt = anterior ? Math.min(t - anterior, 100) : 0;
      anterior = t;
      if (visivel && !hover && !arrasto && t > paradoAte && volta > 0 && !document.hidden) {
        pos = dentro(pos + velocidade * dt / 1000);
        vp.scrollLeft = pos;
      }
      requestAnimationFrame(frame);
    }

    // Scroll feito pela pessoa (dedo, trackpad, roda): segue a partir daí
    // (o scroll que o próprio script faz fica a <2px de pos e é ignorado)
    vp.addEventListener('scroll', function () {
      var x = vp.scrollLeft;
      if (Math.abs(x - pos) < 2) return;
      pausar();
      var y = dentro(x);
      if (y !== x && !arrasto) { vp.scrollLeft = y; }
      pos = y;
    }, { passive: true });

    vp.addEventListener('touchstart', pausar, { passive: true });
    vp.addEventListener('wheel', pausar, { passive: true });
    vp.addEventListener('mouseenter', function () { hover = true; });
    vp.addEventListener('mouseleave', function () { hover = false; anterior = 0; });

    // Arrastar com o rato no computador
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrasto = { x: e.clientX, s: vp.scrollLeft };
      moveu = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrasto) return;
      var dx = e.clientX - arrasto.x;
      if (Math.abs(dx) > 4) { moveu = true; vp.classList.add('is-dragging'); }
      if (moveu) {
        var x = arrasto.s - dx;
        var y = dentro(x);
        if (y !== x) { arrasto.s += y - x; }
        pos = y;
        vp.scrollLeft = y;
      }
    });
    window.addEventListener('pointerup', function () {
      if (!arrasto) return;
      arrasto = null;
      vp.classList.remove('is-dragging');
      pausar();
    });
    // Um arrasto não conta como clique num link/foto
    vp.addEventListener('click', function (e) {
      if (moveu) { e.preventDefault(); e.stopPropagation(); moveu = false; }
    }, true);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visivel = es[0].isIntersecting;
        anterior = 0;
      }, { rootMargin: '100px 0px' }).observe(vp);
    } else { visivel = true; }

    medir();
    window.addEventListener('resize', medir);
    // As fotos podem chegar depois e mudar larguras
    track.addEventListener('load', medir, true);
    if ('ResizeObserver' in window) { new ResizeObserver(medir).observe(track); }

    requestAnimationFrame(frame);
  }

  function todos() {
    var els = document.querySelectorAll('[data-hs-loop]');
    for (var i = 0; i < els.length; i++) { iniciar(els[i]); }
  }
  window.hsLoopCarousel = todos;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todos);
  } else { todos(); }
  // Editor de temas: secções recarregadas
  document.addEventListener('shopify:section:load', todos);
})();
